// Банки, у которых есть колонка в таблице «Кредитного отдела».
// short — подпись под логотипом, строки разделены "\n"; name — полное название для подсказки.
// logo — файл в /svg/banks, если он не совпадает со slug; round — круглая обрезка логотипа.
class BankData {
    static data() {
        return {
            tinkoff: {slug: "tinkoff", name: "Т-Банк", short: "Т-Банк"},
            absolut: {slug: "absolut", name: "Абсолют", short: "Абсолют"},
            zenit: {slug: "zenit", name: "Зенит", short: "Зенит"},
            orange: {slug: "orange", name: "Оранжевый", short: "Оранжевый"},
            sovcom: {slug: "sovcom", name: "Совком", short: "Совком"},
            locko: {slug: "locko", name: "Локо", short: "Локо"},
            expo: {slug: "expo", name: "Экспо", short: "Экспо"},
            primsoc: {slug: "primsoc", name: "Примсоц", short: "Примсоц"},
            rusnarbank: {slug: "rusnarbank", name: "Руснарбанк", short: "Руснарбанк"},
            driveclick: {slug: "driveclick", name: "Драйв Клик", short: "Драйв Клик"},
            soyuz: {slug: "soyuz", name: "Союз", short: "Союз", round: true},
            bystrobank: {slug: "bystrobank", name: "БыстроБанк", short: "БыстроБанк", round: true},
            rosbank: {slug: "rosbank", name: "Росбанк", short: "Росбанк", round: true},
            vologzhanin: {slug: "vologzhanin", name: "Вологжанин", short: "Вологжанин", round: true},
            atb: {slug: "atb", name: "АТБ", short: "АТБ", round: true},
            otpbank: {slug: "otpbank", name: "ОТП", short: "ОТП", round: true},
            crediteurope: {slug: "crediteurope", name: "Кредит Европа", short: "Кредит\nЕвропа", round: true},
            cashdrive: {slug: "cashdrive", name: "Кэшдрайв", short: "Кэшдрайв", round: true},
            vtb: {slug: "vtb", name: "ВТБ", short: "ВТБ", round: true},
            rosgosstrah: {slug: "rosgosstrah", name: "РосГосСтрах", short: "РосГосСтрах", round: true},
            otkrytie: {slug: "otkrytie", name: "Открытие", short: "Открытие", round: true},
            alfabank: {slug: "alfabank", name: "Альфа-Банк", short: "Альфа-Банк", round: true},
            "freedom-finance": {slug: "freedom-finance", name: "Фридом Финанс", short: "Фридом\nФинанс", round: true},
            uralsib: {slug: "uralsib", name: "Уралсиб", short: "Уралсиб", round: true},
            gazprombank: {slug: "gazprombank", name: "Газпромбанк", short: "Газпромбанк", round: true},
            broxi: {slug: "broxi", name: "Broxi (Брокер)", short: "Broxi", round: true},
            mbrusbank: {slug: "mbrusbank", name: "МБ РУС Банк", short: "МБ РУС", round: true},
            ingobank: {slug: "ingobank", name: "Ингосстрах Банк", short: "Ингосстрах", round: true},
            sber: {slug: "sber", name: "СберБанк", short: "СберБанк", round: true},
            sngb: {slug: "sngb", name: "СНГБанк", short: "СНГБанк", round: true},
            psbank: {slug: "psbank", name: "Промсвязьбанк", short: "Промсвязьбанк", round: true},
            levoberezhny: {slug: "levoberezhny", name: "Левобережный", short: "Левобережный", round: true},
            mts: {slug: "mts", name: "МТС Банк", short: "МТС Банк", round: true},
            renessans: {slug: "renessans", name: "Ренессанс Банк", short: "Ренессанс", logo: "renessans-bank.svg", round: true},
            energobank: {slug: "energobank", name: "Энергобанк", short: "Энергобанк", round: true},
            appruvo: {slug: "appruvo", name: "Appruvo", short: "Appruvo", round: true},
            europlan: {slug: "europlan", name: "Европлан", short: "Европлан", round: true},
            reso: {slug: "reso", name: "Ресо", short: "Ресо", round: true},
            autofinancebank: {slug: "autofinancebank", name: "Авто Финанс Банк", short: "Авто\nФинанс", round: true},
            royalcreditbank: {slug: "royalcreditbank", name: "Роял Кредит Банк", short: "Роял\nКредит", round: true},
        };
    }
    static has(slug) {
        return Object.prototype.hasOwnProperty.call(this.data(), slug);
    }
    static get(slug) {
        return this.data()[slug] || null;
    }
    static logoUrl(slug) {
        let bank = this.get(slug);
        return '/svg/banks/' + (bank && bank.logo ? bank.logo : slug + '.svg');
    }
    static isRoundLogo(slug) {
        let bank = this.get(slug);
        return !!(bank && bank.round);
    }
}

export default BankData;
